module.exports = __webpack_public_path__ + "static/media/normal.93435df6.png";